import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import { Paginator } from 'primereact/paginator';

function App() {
    const userID = sessionStorage.getItem("TRCUserId");
    const userEmail = sessionStorage.getItem("TRCUserEmail");
    const userName = sessionStorage.getItem("TRCUserName");
    const userPosition = sessionStorage.getItem("TRCUserPosition");
    const userType = sessionStorage.getItem("TRCUserType");
    const dates = sessionStorage.getItem("newDate") || '';
    const [getData, setGetData] = useState('');
    const [first, setFirst] = useState(0); 
    const [rows, setRows] = useState(10); 
    const [date, setDate] = useState(dates);
    const [filterData, setFilterData] = useState('');
    const [type, setType] = useState('');
    const [dealerSearch, setDealerSearch] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRoutes, setSelectedRoutes] = useState(['all']);
    const [allRoutes, setAllRoutes] = useState([]);
    const [selectedVnum, setSelectedVnum] = useState('all');
    const [allVnum, setAllVnum] = useState([]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleRouteSelection = (route) => {
        if (route === 'all') {
            if (selectedRoutes.includes('all')) {
                setSelectedRoutes([]);
            } else {
                setSelectedRoutes(['all']);
            }
        } else {
            if (selectedRoutes.includes(route)) {
                const updatedRoutes = selectedRoutes.filter(r => r !== route);
                if (updatedRoutes.length === 0) {
                    setSelectedRoutes(['all']);
                } else {
                    setSelectedRoutes(updatedRoutes.filter(r => r !== 'all'));
                }
            } else {
                const updatedRoutes = [...selectedRoutes.filter(r => r !== 'all'), route];
                setSelectedRoutes(updatedRoutes);
            }
        }
    };

    const isRouteSelected = (route) => {
        return selectedRoutes.includes('all') || selectedRoutes.includes(route);
    };

    const handleVnumChange = (e) => {
        setSelectedVnum(e.target.value);
    };

    const formatDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };

    const changeDate = async (e) => {
        const date = e.target.value;
        sessionStorage.setItem("newDate", date);
        sessionStorage.getItem("newPage", 0);
        setFirst(0);
        const newDate = new Date(date);
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
        setDate(formattedDate);

        try {
            const response = await axios.post('https://api.trucoo.in/orders/all-orders/', {date: formattedDate}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });

            if(response.data.status === 'success'){
                const filterData = response.data.data.filter(datas => datas.status === 'Approved' && datas.type === 'order');
                setGetData(filterData);
                setFilterData(filterData);
                setDate(response.data.date);
                
                // Extract unique routes and vehicle numbers from the orders
                const routes = [...new Set(filterData.map(order => order.dealerData?.routes || '').filter(r => r))];
                const vnums = [...new Set(filterData.map(order => order.vNum || '').filter(v => v))];
                setAllRoutes(routes);
                setAllVnum(vnums);
            }else{
                setGetData([]);
                setFilterData([]);
                setDate(response.data.date);
                setAllRoutes([]);
                setAllVnum([]);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const getdata = async (date) => {
        const newDate = new Date(date);
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
        setDate(formattedDate);
        try {
            const response = await axios.post('https://api.trucoo.in/orders/all-orders/', {date: formattedDate},{
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            if(response.data.status === 'success'){
                const filterData = response.data.data.filter(datas => datas.status === 'Approved'  && datas.type === 'order');
                setGetData(filterData);
                setFilterData(filterData);
                setDate(response.data.date);
                
                // Extract unique routes and vehicle numbers from the orders
                const routes = [...new Set(filterData.map(order => order.dealerData?.routes || '').filter(r => r))];
                const vnums = [...new Set(filterData.map(order => order.vNum || '').filter(v => v))];
                setAllRoutes(routes);
                setAllVnum(vnums);
            }else{
                setGetData([]);
                setFilterData([]);
                setDate(response.data.date);
                setAllRoutes([]);
                setAllVnum([]);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const onPageChange = (event) => {
        setFirst(event.first);
        sessionStorage.setItem("newPage", event.first);
    };

    useEffect(() => {
        const page = parseFloat(sessionStorage.getItem("newPage") || 0);
        setFirst(page);
        if(dates && dates !== null){
            getdata(dates);
        }else{
            const today = new Date();
            const formattedDate = today.toLocaleDateString();
            getdata(formattedDate);
        }
    }, []);

    let filterOrders = [];

    if (type || dealerSearch || selectedVnum !== 'all' || (selectedRoutes.length > 0 && !selectedRoutes.includes('all'))) {
        filterOrders = getData.filter(data => {
            const matchInvoice = type && type !== '' ? data.invoice === type : true;
            const matchDealer = dealerSearch ? data.dealerData?.dealer?.toLowerCase().includes(dealerSearch.toLowerCase()) : true;
            const matchVnum = selectedVnum !== 'all' ? data.vNum === selectedVnum : true;
            const matchMultiRoute = selectedRoutes.length > 0 && !selectedRoutes.includes('all') 
                ? selectedRoutes.includes(data.dealerData?.routes)
                : true;
            
            return matchInvoice && matchDealer && matchVnum && matchMultiRoute;
        });
    } else {
        filterOrders = getData;
    }

    let cratesTotal = 0;
    let qtyTotal = 0;
    let weightTotal = 0;
    let orderTotal = 0;

    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
            
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Approved Orders</h4>
							    <hr />
                                        <div className="row">
                                            <div className="col-md-2">
                                                <label>Date</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={formatDate(date)} 
                                                    onChange={(e) => changeDate(e)} 
                                                />
                                            </div>
                                            
                                            <div className="col-md-2">
                                                <label>Invoice Status</label>
                                                <select 
                                                    className="form-control" 
                                                    value={type} 
                                                    onChange={(e) => setType(e.target.value)} 
                                                >
                                                    <option value="">Both</option>
                                                    <option value="yes">Created</option>
                                                    <option value="no">Not Created</option>
                                                </select>
                                            </div>

                                            <div className="col-md-2">
                                                <label>Dealer Search</label>
                                                <input
                                                    type="text"
                                                    placeholder="Search Dealer"
                                                    className="form-control"
                                                    value={dealerSearch}
                                                    onChange={(e) => setDealerSearch(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-2">
                                                <label>Routes</label>
                                                <div className="dropdown">
                                                    <button 
                                                        className="form-control text-start" 
                                                        onClick={toggleDropdown}
                                                        style={{textAlign: 'left'}}
                                                    >
                                                        {selectedRoutes.includes('all') ? 'All Routes' : `${selectedRoutes.length} Routes Selected`}
                                                    </button>
                                                    {isOpen && (
                                                        <div className="dropdown-menu show" style={{ minWidth: '250px', padding: '8px' }}>
                                                            <div className="mb-2 d-flex justify-content-between align-items-center border-bottom pb-2">
                                                                <strong>Select Routes</strong>
                                                                <button className="btn btn-sm btn-light" onClick={toggleDropdown}>
                                                                    ×
                                                                </button>
                                                            </div>

                                                            <div className="dropdown-item py-1">
                                                                <div className="form-check d-flex align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        style={{ opacity: 0, position: 'absolute', left: '10px'}}
                                                                        id="allRoutesCheckbox"
                                                                        value="all"
                                                                        checked={selectedRoutes.includes('all')}
                                                                        onChange={() => handleRouteSelection('all')}
                                                                    />
                                                                    <label 
                                                                        className="form-check-label ms-3" 
                                                                        htmlFor="allRoutesCheckbox"
                                                                        style={{ paddingLeft: '24px' }}
                                                                    >
                                                                        All Routes
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {allRoutes.map((route) => (
                                                                <div key={route} className="dropdown-item py-1">
                                                                    <div className="form-check d-flex align-items-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            style={{ opacity: 0, position: 'absolute', left: '10px'}}
                                                                            id={`routeCheckbox-${route}`}
                                                                            value={route}
                                                                            checked={isRouteSelected(route)}
                                                                            onChange={() => handleRouteSelection(route)}
                                                                        />
                                                                        <label
                                                                            className="form-check-label ms-3"
                                                                            htmlFor={`routeCheckbox-${route}`}
                                                                            style={{ paddingLeft: '24px' }}
                                                                        >
                                                                            {route}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <label>Vehicle Number</label>
                                                <select 
                                                    className="form-control" 
                                                    value={selectedVnum} 
                                                    onChange={handleVnumChange}
                                                >
                                                    <option value="all">All Vehicles</option>
                                                    {allVnum.map((vnum, index) => (
                                                        <option key={index} value={vnum}>{vnum}</option>
                                                    ))}
                                                </select>
                                          
                                    </div>
                                </div>
                            </div>

                            <div className="box-body">
                                <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 310px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th width="7%">Date</th>
                                                <th>Dealer</th>
                                                <th>Crates</th>
                                                <th>QTY</th>
                                                <th>L/KGs</th>
                                                <th>Amount</th>
                                                <th>Route</th>
                                                <th>Place</th>
                                                <th>Phone</th>
                                                <th>Invoice</th>
                                                <th>Vehicle No</th>
                                                <th>Options</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filterOrders?.length > 0 ? 
                                                <>
                                                    {filterOrders?.map((data, index) => {
                                                        cratesTotal += data?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty), 0);
                                                        qtyTotal += data?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item.crates), 0);
                                                        weightTotal += data?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item?.crates * (item?.weight/1000)), 0);
                                                        orderTotal += Number(data.totalPayment);

                                                        return (
                                                            <tr key={index}>
                                                                <td class="text-center">{formatViewDate(data.orderDate)}</td>
                                                                <td className="text-dark">{data.dealerData?.dealer}</td>
                                                                <td class="text-end">{data?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty), 0).toFixed(2)}</td>
                                                                <td class="text-end">{data?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item?.crates), 0).toFixed(2)}</td>
                                                                <td class="text-end">{data?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item?.crates) * (item?.weight/1000), 0).toFixed(2)}</td>
                                                                <td class="text-end">{Number(data?.totalPayment).toFixed(2)}</td>
                                                                <td>{data.dealerData?.routes}</td>
                                                                <td>{data.dealerData?.locations}</td>
                                                                <td>{data.dealerData?.phone}</td>
                                                                <td className={data.invoice === 'no' ? 'btn-danger fs-10' : 'btn-success fs-10'}>
                                                                    {data.invoice === 'no' ? 'Not Created' : 'Created'}
                                                                </td>
                                                                <td>{data.vNum || '-'}</td>
                                                                <td>
                                                                    <a href={`/dealer-details?id=${data.orderId}`} className="form-control" style={{textAlign: 'center'}}>View</a>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}

                                                    <tr>
                                                        <th colSpan={2} className='text-left'>Total</th>
                                                        <th className='text-end'>{cratesTotal.toFixed(2)}</th>
                                                        <th className='text-end'>{qtyTotal.toFixed(2)}</th>
                                                        <th className='text-end'>{weightTotal.toFixed(2)}</th>
                                                        <th className='text-end'>{orderTotal.toFixed(2)}</th>
                                                        <th colSpan={6}></th>
                                                    </tr>
                                                </>
                                            : (
                                                <tr>
                                                    <td colSpan={12} className='text-center p-4'>No Orders</td>
                                                </tr>
                                            )}
                                        </tbody>    
                                    </table>
                                </div>              
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {/* <Footer /> */}
        </>
    );
}

export default App;